interface IProps {
  htmlFor: string;
  className?: string;
  children: string;
}

const Label = ({ htmlFor, children, className }: IProps) => {
  return (
    <label htmlFor={htmlFor} className={className}>
      {children}
    </label>
  );
};

export default Label;
